// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"221":"8be8f93b","367":"8be8f93b","549":"585946c0","561":"b7916003","749":"f4e89112"}[chunkId] + ".chunk.css";
};